const processInclude = require('base/util');

$(() => {
  processInclude(require('./login/login'));
});
